// Definição para o modal de busca de Unidades de Medida de Conversão de um Produto
// Factory function - recebe idProduto como filtro obrigatório
// Retorna a unidade base (com badge "Base") e as unidades de conversão ativas
// (com badge "Venda" para a unidade padrão de venda)
//
// displayField = lstUnidadeMedidaExibicao (texto da lista para exibição no input)
// descField = lstUnidadeMedidaDescricao (descrição detalhada no label informativo)
// idField = lstUnidadeMedidaTexto (código da lista, salvo como modelValue)

import { ST } from '@/constants/ST'

export const criarConfigBuscaUnidadeMedidaProduto = (idProduto) => ({
  label: 'Unidade de Medida',
  placeholder: 'Buscar unidade...',
  titulo: 'Unidades de Medida do Produto',
  endpointApi: 'ProdutoConversaoUnidades',
  endpointFetchPorCodigo: 'ProdutoConversaoUnidades',
  idField: 'lstUnidadeMedidaTexto',
  displayField: 'lstUnidadeMedidaExibicao',
  descField: 'lstUnidadeMedidaDescricao',
  colunasGrid: [
    {
      header: 'Unidade',
      dataField: 'lstUnidadeMedidaExibicao',
      width: '120px'
    },
    {
      header: 'Descrição',
      dataField: 'lstUnidadeMedidaDescricao',
      width: '200px'
    },
    {
      header: 'Fator',
      dataField: 'fatorDisplay',
      width: '180px',
      allowHtml: true,
      formatter: (value, row) => {
        const fator = Number(row.fatorConversao) || 1
        const unidadeBaseExibicao = row.lstUnidadeMedidaBaseExibicao || ''
        return `${fator} ${unidadeBaseExibicao}`
      }
    },
    {
      header: 'Tipo',
      dataField: 'tipoDisplay',
      width: '140px',
      align: 'center',
      allowHtml: true,
      formatter: (value, row) => {
        const badges = []
        if (row.isBase) {
          badges.push('<span class="badge bg-secondary">Base</span>')
        }
        if (row.unidadePadraoVenda) {
          badges.push('<span class="badge bg-success ms-1">Venda</span>')
        }
        return badges.join(' ') || '<span class="text-muted">-</span>'
      }
    }
  ],
  camposFiltro: [
    { model: 'busca', label: 'Buscar unidade...', tipo: 'text' }
  ],
  filtrosFixos: { idProduto, lstStatus: ST.Ativo }
})
